import { render } from "./RequestsPage.vue?vue&type=template&id=015685bb"
import script from "./RequestsPage.vue?vue&type=script&lang=js"
export * from "./RequestsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RequestsPage.vue?vue&type=style&index=0&id=015685bb&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__